<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.sync_to_area') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="area" :label="$t('attributes.area')">
              <b-select
                v-model="form.area"
                :loading="loadingAreas"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                @input="onSelectArea"
              >
                <option value="">
                  {{ $t('attributes.all_area') }}
                </option>
                <option
                  v-for="option in areas"
                  :value="option"
                  :key="option.code"
                >
                  {{ !option.status ? '[下架]' : '' }}
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-info"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.sync') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'BannerSyncForm',
  props: {
    banner: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      loadingAreas: false,
      areas: [],
      selectedArea: null,

      sortOptions: [...Array(20).keys()].map(i => i + 1),

      form: this.extractFormValues(this.banner)
    }
  },
  validations: {
    form: {
      id: { required },
      area_code: { required },
      sort: { required }
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        area_code: null,
        sort: 2
      }
    },
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.selectedArea = null
      } catch (e) {
        this.areas = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    onSelectArea(item) {
      this.form.area_code = item.code
    },
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
